var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgilysysIgQuickPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2139.1 431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #0299d6;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #7fbc42;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #231f20;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M518.8,353.9h-29.9v-216.8h29.9v216.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M731.7,145.9l-4.9,23.8c-18.6-7.5-39.4-12-59.6-12-53.7,0-86.6,32.9-86.6,90.5s29.6,86.3,87.2,86.3,29-2.3,39.1-5.2v-70.6h27.3v87.2c-16.3,6.8-44.6,12-70,12-71.3,0-113.6-44.9-113.6-109.7s43.6-114.9,116.2-114.9,47.2,4.2,64.8,12.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M831.9,245.5c0-60.2,37.8-112.3,105.8-112.3s105.8,52.1,105.8,112.3-19.5,82.7-56,101.2l53.7,33.9-14,22.1-71.6-46.2c-5.5.7-11.7,1.3-17.9,1.3-68,0-105.8-52.1-105.8-112.3ZM1013.5,245.5c0-48.8-26-88.2-75.8-88.2s-75.8,39.4-75.8,88.2,26,88.2,75.8,88.2,75.8-39.4,75.8-88.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1207.9,197.6v156.2h-28v-22.8c-11.1,15.3-28.3,26-49.8,26-38.7,0-54-35.8-54-77.1v-82.4h29.3v81.4c0,31.9,7.5,54.4,34.5,54.4s30.6-11.1,38.7-21.2v-114.6h29.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1263.2,132.9c11.1,0,18.6,8.5,18.6,18.6s-7.5,18.6-18.6,18.6-18.6-8.5-18.6-18.6,7.5-18.6,18.6-18.6ZM1248.5,353.9v-156.2h29.3v156.2h-29.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1434.4,202.8l-4.2,22.5c-11.4-4.6-24.4-7.5-37.1-7.5-35.2,0-51.4,23.8-51.4,57.9s16.3,57.9,51.4,57.9,25.7-2.9,37.1-7.5l4.2,22.5c-10.7,5.2-29.3,8.5-43.9,8.5-52.4,0-78.1-37.8-78.1-81.4s25.7-81.4,78.1-81.4,33.2,3.3,43.9,8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1465.3,353.9V124.1h29.3v147.5l62.5-73.9h33.9l-66.1,76.8,71.6,79.4h-35.5l-66.4-77.5v77.5h-29.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1734.8,268.3h-15v85.6h-29.9v-216.8h52.4c46.5,0,83,20.8,83,63.5s-39.1,67.7-90.5,67.7ZM1741.4,161.2h-21.5v83h15.9c34.8,0,59.6-16.3,59.6-43.9s-24.4-39.1-54-39.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1938.3,334.3c-9.1,11.4-28.6,22.8-52.1,22.8s-44.6-16.9-44.6-43.3,21.8-43,55.7-45.2c14-1,27.7-1.3,40.4-1.3v-6.8c0-26.4-10.7-42.3-36.5-42.3s-29,4.2-41.3,11.1l-6.8-21.5c16.3-9.8,33.2-13.3,53.4-13.3,36.8,0,60.5,23.4,60.5,65.4v94.1h-28.6v-19.5ZM1937.6,315.5v-29c-13,.7-24.1,1.6-35.2,2.9-18.2,2-32.5,7.5-32.5,24.4s9.1,21.8,24.7,21.8,32.2-8.5,43-20.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2017.4,420.9l23.1-65.4-57.3-157.9h30.3l41,127.9,40.4-127.9h30.3l-79.1,223.3h-28.6Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377.7,178.1c46.4,0,84.1-37.6,84.1-84.1S424.2,10,377.7,10s-84.1,37.6-84.1,84.1,37.6,84.1,84.1,84.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.9,123c10.5,13.7,16.3,32.4,16.3,55.7v118h-35.9v-24.5c-11.4,14.3-35.9,28.6-65.3,28.6s-55.9-21.2-55.9-54.3,27.4-53.9,69.8-56.7c17.6-1.2,34.7-1.6,50.6-1.6v-8.6c0-33.1-13.5-53.1-45.7-53.1s-36.3,5.3-51.8,13.9l-8.6-26.9c20.4-12.2,41.6-16.7,66.9-16.7s12.7.6,18.5,1.8c-17.9-7.2-37.4-11.2-57.9-11.2-85.4,0-154.7,69.3-154.7,154.7s69.3,154.7,154.7,154.7,154.7-69.3,154.7-154.7-21.7-90.5-55.7-118.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.6,246.4c0,18.4,11.4,27.3,31,27.3s40.4-10.6,53.9-25.3v-36.3c-16.3.8-30.2,2-44.1,3.7-22.9,2.4-40.8,9.4-40.8,30.6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgilysysIgQuickPay);
export default __webpack_public_path__ + "static/media/AgilysysIGQuickPay.4680aaf6c153b193732c749e7638aba6.svg";
export { ForwardRef as ReactComponent };